import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Title, FileCard, Note } from 'components/misc'
import { FileLoader } from 'components/loaders'
import { get } from 'lodash'
import { apiDashboard } from 'helpers/decorators/api'

@apiDashboard.apiAdventurousJourney()
class AJAttachedFiles extends Component {
  static propTypes = {
    ajId: PropTypes.number,
    aJValues: PropTypes.object.isRequired,
    getAJfiles: PropTypes.func.isRequired
  }

  componentWillMount = () => {
    this.props.getAJfiles(this.props.ajId)
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.ajId !== nextProps.ajId) {
      this.props.getAJfiles(nextProps.ajId)
    }
  }

  render() {
    const { aJValues } = this.props
    const files = get(aJValues, 'ajFiles', [])

    return (
      <div className="row">
        <div className="col-xs-12">
          <Title intlKey="moduleTitle.additional_files" hasOverviewHeading h3>
            Additional files
          </Title>
          {!aJValues.filesLoading &&
            files.length === 0 && (
              <Note intlKey="moduleTitle.no_additional_files">
                No additional files found
              </Note>
            )}
        </div>

        {!aJValues.filesLoading ? (
          files.map(file => (
            <div className="col-xs-12 col-md-6" key={file.id}>
              <FileCard file={file} src={file.fileUrl} />
            </div>
          ))
        ) : (
          <div className="col-xs-12">
            <FileLoader secondary />
          </div>
        )}
      </div>
    )
  }
}

export default AJAttachedFiles
